import { Box, ButtonBase, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import { DropdownBase, DropdownBaseV2 } from "../../../../../components/theme/dropdowns/Dropdown";
import { tokens } from "../../../../../theme";
import EcheckCarrier, { DraggedRowPreview, EcheckCarrierBundle, EcheckCarrierBundleReadonly, EcheckCarrierReadOnly } from "../EcheckCarrier";
import EcheckInvoiceCosts, { EcheckInvoiceCostsReadOnly } from "../InvoiceCosts";

import {
    closestCenter,
    DndContext,
    DragOverlay,
    PointerSensor,
    rectIntersection,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import { useState } from "react";
import MEcheckEditAmountToMove from "../../../../../components/global/Modals/MEcheckEditAmountToMove";
import { moveRow, parseDragId } from "../../helper";
import Subheading from "../../../../../components/theme/text/Subheading";
import Heading from "../../../../../components/theme/text/Heading";


const CarrierView = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode); 
    const sensors = useSensors(useSensor(PointerSensor));

    const {t} = useTranslation();

    const [activeDragItem, setActiveDragItem] = useState(null);

    const [toAndFromData, setToAndFromData] = useState(null);

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }
    
    const handleClose = (toMove, amountToMove) => {
        setAddModalOpen(false);
        if (toMove) {
            const updatedCarriers = moveRow(
                props.carriers, 
                toAndFromData.from, 
                toAndFromData.to,
                true, //makes sure it goes through
                amountToMove
            );
            props.setCarriers(updatedCarriers);
            setToAndFromData(null);
            if(props.playSuccess) props.playSuccess();
            
        }
    };

    const  handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over) return;

        const from = parseDragId(active.id);
        const to = parseDragId(over.id);

        // Normalize null/NaN/undefined bundleIndex to same value
        const normalizeIndex = (val) => Number.isFinite(val) ? val : null;
        const fromBundle = normalizeIndex(from.bundleIndex);
        const toBundle = normalizeIndex(to.bundleIndex);

        // Check if drop target is different from drag source
        if (
            fromBundle === toBundle &&
            from.carrierIndex === to.carrierIndex 
        ) {
            setActiveDragItem(null);
            return; 
        }

        const updatedCarriers = moveRow(props.carriers, from, to);

        //We return object in the case the amount in the row is more than 1
        //This is so we can show a modal for you to make a decision wether to move all
        // or just 1, we default the modal to all
        if(Array.isArray(updatedCarriers)){
            if(props.playSuccess) props.playSuccess();
            props.setCarriers(updatedCarriers);
        } else {
            setToAndFromData({
                from,
                to,
                fromRow:updatedCarriers
            });
            addModal.setOpen(true);
        }
        setActiveDragItem(null);
    }
    return (
        <Box 
            sx={{
                flex:1,
                display:'flex',
                flexDirection:"column",
                gap:2,
            }}
        >

            <DndContext
                sensors={sensors}
                collisionDetection={rectIntersection}
                onDragEnd={handleDragEnd}
                onDragStart={(event) => {
                    setActiveDragItem(event.active.id); // Track the ID
                }}
            >
                {props.carriers && props.carriers?.map((carrier, carrierIndex) => (
                    carrier.bundle ?
                        <EcheckCarrierBundle
                            hasAllowedToSetCustomCarrierShipperPermission={props.hasAllowedToSetCustomCarrierShipperPermission}
                            playSuccess={props.playSuccess}
                            playError={props.playError}
                            autoFinalize={props.autoFinalize}
                            carrierMandatory={props.carrierMandatory}
                            selectedShipper={props.selectedShipper}
                            selectedShipperProfile={props.selectedShipperProfile}
                            setGoFinalize={props.setGoFinalize}
                            carrierToAddTo={props.carrierToAddTo}
                            setCarrierToAddTo={props.setCarrierToAddTo}
                            setCarriers={props.setCarriers}
                            key={"containerview"+carrierIndex}
                            deliveryOptions={props.deliveryOptions}
                            selectLabel={props.selectLabel}
                            selectManualCarrier={props.selectManualCarrier}
                            OwnCarrierClick={props.OwnCarrierClick}
                            carriersSelect={props.carriersSelect}
                            carrier={carrier}
                            carrierIndex={carrierIndex}
                            isBundling={props.isBundling}
                            activeDragItem={activeDragItem}
                            toScanRows={props.toScanRows}
                            maxCarrierAmount={props.maxCarrierAmount}
                            setToScanRows={props.setToScanRows}
                            setOriginalOrderlines={props.setOriginalOrderlines}
                            setSkuSerialMap={props.setSkuSerialMap}
                            setHighlightColor={props.setHighlightColor}
                            shippers={props.shippers}
                            currentOrder={props.currentOrder}
                            clearInstructionShown={props.clearInstructionShown}
                        />

                    :
                    <EcheckCarrier
                        hasAllowedToSetCustomCarrierShipperPermission={props.hasAllowedToSetCustomCarrierShipperPermission}
                        playSuccess={props.playSuccess}
                        playError={props.playError}

                        autoFinalize={props.autoFinalize}
                        carrierMandatory={props.carrierMandatory}
                        selectedShipper={props.selectedShipper}
                        selectedShipperProfile={props.selectedShipperProfile}
                        setGoFinalize={props.setGoFinalize}
                        dragId={`carrier-${carrierIndex}`}
                        carrierToAddTo={props.carrierToAddTo}
                        setCarrierToAddTo={props.setCarrierToAddTo}
                        newBundle={props.newBundle}
                        setNewBundle={props.setNewBundle}
                        setCarriers={props.setCarriers}
                        key={"containerview"+carrierIndex}
                        deliveryOptions={props.deliveryOptions}
                        selectLabel={props.selectLabel}
                        selectManualCarrier={props.selectManualCarrier}
                        OwnCarrierClick={props.OwnCarrierClick}
                        carriersSelect={props.carriersSelect}
                        carrier={carrier}
                        carrierIndex={carrierIndex}
                        isBundling={props.isBundling}
                        toScanRows={props.toScanRows}
                        maxCarrierAmount={props.maxCarrierAmount}
                        setToScanRows={props.setToScanRows}
                        setOriginalOrderlines={props.setOriginalOrderlines}
                        setSkuSerialMap={props.setSkuSerialMap}
                        setHighlightColor={props.setHighlightColor}

                        activeDragItem={activeDragItem}
                        shippers={props.shippers}
                        currentOrder={props.currentOrder}
                        clearInstructionShown={props.clearInstructionShown}
                    />
                ))}
                <DragOverlay
                    dropAnimation={{
                        duration: 0, 
                    }}
                >
                    {activeDragItem ? <DraggedRowPreview dragId={activeDragItem} carriers={props.carriers} /> : null}
                </DragOverlay>
            </DndContext>

            {/* {(
               ( (
                    props.carriers?.[props.carriers.length - 1]?.bundle
                        ? (
                            props.carriers[props.carriers.length - 1].carriers?.[props.carriers[props.carriers.length - 1].carriers.length - 1]?.rows?.length !== 0 &&
                            props.carriers[props.carriers.length - 1].carriers?.[props.carriers[props.carriers.length - 1].carriers.length - 1]?.carrierName !== ""
                        )
                        : (
                            props.carriers?.[props.carriers.length - 1]?.rows?.length !== 0 &&
                            props.carriers[props.carriers.length - 1]?.carrierName !== ""
                        )
                ) && props.toScanRows.length > 0) || props.toScanRows.length === 0
            ) &&  */}
                {/* <Box
                    sx={{
                        // mt:3,
                        background: theme.palette.mode === "dark" ? colors.grey[500] : colors.bg["tertiary"],
                        borderRadius: 4,
                        overflow: "hidden",
                        display: "flex",
                        paddingBottom: 3,
                        postion:"relative",
                        px:2,
                        py:2,
                        gap:2,
                    }}
                >
                    <DropdownBaseV2
                        key={props.carriers?.length}
                        transformOrigin={{
                            vertical: "bottom"
                        }}
                        anchorOrigin={{
                            vertical:"top"
                        }}
                        displayName={"name"} 
                        onChange={(selected) => props.selectManualCarrier(selected)}
                        noSelection={t("choose_carrier")} //Custom text when nothing is selected
                        options={props.carriersSelect}
                        selected={-1}
                        closeOnSelection
                        resetOnSelection
                        stopPropagation
                        noPropagationOnSelect
                    >
                        {({anchorEl,onClick}) => (
                            <Shbutton 
                                className={"group-btn"} 
                                sx={{whiteSpace:"nowrap"}} 
                                color={"primaryGrey"} 
                                variant="contained"
                                onClick={onClick}
                                stopPropagation
                            >
                                {t("choose_carrier")}
                            </Shbutton>
                        )}
                    </DropdownBaseV2>

                    <Shbutton className={"group-btn"} sx={{whiteSpace:"nowrap"}} color={"primaryGrey"} variant="contained" onClick={() => props.OwnCarrierClick()}>{t("own_carrier")}</Shbutton>
                </Box> */}
            {/* } */}
            {(() => {
                const lastCarrier = props.carriers?.[props.carriers.length - 1];

                if (!lastCarrier) return null;

                if (lastCarrier.bundle) {
                    const subCarriers = lastCarrier.carriers;
                    const lastSubCarrier = subCarriers?.[subCarriers.length - 1];

                    if (
                        !lastSubCarrier 
                        || lastSubCarrier.rows?.length === 0
                        //  || lastSubCarrier.carrierId === null
                    ) {
                        return null;
                    }
                } else {
                    if (
                        lastCarrier.rows?.length === 0 
                        // || lastCarrier.carrierId === null

                    ) {
                        return null;
                    }
                }

                const allCarriers = props.carriers.flatMap(carrier => {
                    return carrier.bundle && Array.isArray(carrier.carriers)
                    ? carrier.carriers
                    : [carrier];
                });

                const totalCarrierCount = allCarriers.length;

                if (totalCarrierCount >= props.maxCarrierAmount) {
                    return null;
                }

                return (

                    <ButtonBase
                        onClick={() => {
                            props.setCarriers(prevCarriers => {
                                const updatedCarriers = [...prevCarriers];
                                updatedCarriers.push({
                                    carrierId: null,
                                    bundle:false,
                                    carrierName: "",
                                    totalProducts: 0,
                                    totalWeight: 0,
                                    deliveryOption: null,
                                    rows: [],
                                });

                                props.setCarrierToAddTo({
                                    bundleIndex: -1,
                                    carrierIndex: updatedCarriers.length - 1,
                                });

                                
                                return updatedCarriers;
                            });
                        }}
                        sx={{
                            background: colors.urbangreen[100],
                            border: `1px dashed ${colors.urbangreen[400]}`,
                            borderRadius: 4,
                            overflow: "hidden",
                            display: "flex",
                            paddingBottom: 3,
                            px: 2,
                            py: 2,
                            gap: 2,
                        }}
                    >
                        <Heading>+</Heading>
                        {/* Content inside Box */}
                        {/* <DropdownBaseV2
                            key={props.carriers?.length}
                            transformOrigin={{ vertical: "bottom" }}
                            anchorOrigin={{ vertical: "top" }}
                            displayName={"name"}
                            onChange={(selected) => props.selectManualCarrier(selected)}
                            noSelection={t("choose_carrier")}
                            options={props.carriersSelect}
                            selected={-1}
                            closeOnSelection
                            resetOnSelection
                            stopPropagation
                            noPropagationOnSelect
                        >
                            {({ anchorEl, onClick }) => (
                            <Shbutton
                                className={"group-btn"}
                                sx={{ whiteSpace: "nowrap" }}
                                color={"primaryGrey"}
                                variant="contained"
                                onClick={onClick}
                                stopPropagation
                            >
                                {t("choose_carrier")}
                            </Shbutton>
                            )}
                        </DropdownBaseV2>

                        <Shbutton
                            className={"group-btn"}
                            sx={{ whiteSpace: "nowrap" }}
                            color={"primaryGrey"}
                            variant="contained"
                            onClick={() => props.OwnCarrierClick()}
                        >
                            {t("own_carrier")}
                        </Shbutton> */}
                    </ButtonBase>
                );
                })()}
            <EcheckInvoiceCosts
                isBundling={props.isBundling}
                invoiceProducts={props.invoiceProducts}
                setInvoiceProducts={props.setInvoiceProducts}
                updateCostProduct={props.updateCostProduct}
                invoiceProductsEcheck={props.invoiceProductsEcheck}
            />


            <MEcheckEditAmountToMove 
                toAndFromData={toAndFromData} 
                onOpen={() => addModal.setOpen(true)} 
                onClose={() => addModal.setOpen(false)} 
                open={addModal.open} 
                handleClose={handleClose}
            />
        </Box>
            

    )
}

export default CarrierView;


export const CarrierViewReadOnly = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode); 
    const sensors = useSensors(useSensor(PointerSensor));

    const {t} = useTranslation();

    
    return (
        <Box 
            sx={{
                flex:1,
                display:'flex',
                flexDirection:"column",
                gap:2,
            }}
        >

            {props.carriers && props.carriers?.map((carrier, carrierIndex) => (
                carrier.bundle ?
                    <EcheckCarrierBundleReadonly
                        shipmentIds={props.shipmentIds}
                        carrierToAddTo={props.carrierToAddTo}
                        setCarrierToAddTo={props.setCarrierToAddTo}
                        setCarriers={props.setCarriers}
                        key={"containerview"+carrierIndex}
                        deliveryOptions={props.deliveryOptions}
                        selectLabel={props.selectLabel}
                        selectManualCarrier={props.selectManualCarrier}
                        OwnCarrierClick={props.OwnCarrierClick}
                        carriersSelect={props.carriersSelect}
                        carrier={carrier}
                        carrierIndex={carrierIndex}
                        hasPickingslip={props.hasPickingslip}
                    />
                
                :
                <EcheckCarrierReadOnly
                    key={"containerview"+carrierIndex}
                    shipmentIds={props.shipmentIds}
                    deliveryOptions={props.deliveryOptions}
                    carrier={carrier}
                    carrierIndex={carrierIndex}
                    readOnly
                    hasPickingslip={props.hasPickingslip}
                />
            ))}
           <EcheckInvoiceCostsReadOnly
                invoiceProducts={props.invoiceProducts}
            />


        </Box>
            

    )
}